import { authConfig } from "../apiConfig";



export const get_categories_with_out_pagination = async () => {
    try {
        const response = await authConfig.post(`getcategoriesLevel`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_categories_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getcategoriesLevel`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_categories_by_id = async (data) => {
    try {
        const response = await authConfig.post(`categoryLevelViewbyID`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const categories_creation = async (data) => {
    try {
        const response = await authConfig.post(`storecategoriesLevels`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const categories_update = async (data) => {
    try {
        const response = await authConfig.post(`updatecategoriesLevel`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const categories_deletion = async (data) => {
    try {
        const response = await authConfig.post(`categoryLevelDelete`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};